import { render } from "./OnboardingPerks.vue?vue&type=template&id=7bb9007e&scoped=true"
import script from "./OnboardingPerks.vue?vue&type=script&lang=js"
export * from "./OnboardingPerks.vue?vue&type=script&lang=js"

import "./OnboardingPerks.vue?vue&type=style&index=0&id=7bb9007e&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bb9007e"]])

export default __exports__